export default "__VITE_ASSET__CPTyKwWs__"